import React, { useState, useEffect } from "react";
import "./formLeaderAttribute.css";
import { Form, Input, Button, Typography, Space, Row, Col, Select } from "antd";

const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const FormLeaderAttribute = (props) => {
    const [isEditing, setIsEditing] = useState(false);

    // Funciones de edición y guardado
    const handleEditClick = () => setIsEditing(true);
    const handleSaveClick = () => {
        setIsEditing(false);
        props.saveLeaderAttribute();
    };

    const handleCreateClick = () => {
        props.saveLeaderAttribute();
    };

    useEffect(() => {
        setIsEditing(false);
    }, [props.latId]);

    const handleBehaviorChange = (index, value) => {
        // ✅ Clonar el array de descriptores sin modificar el original
        const updatedBehaviors = [...props.latBehaviors];
        updatedBehaviors[index].lab_behavior = value
        props.setLatBehaviors(updatedBehaviors);
    };

    return (
        <Form layout="horizontal">
            {/* Nombre del atributo del líder */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Nombre:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newLeaderAttribute ? (
                        <Input 
                            value={props.latLeaderAttribute} 
                            onChange={(e) => props.setLatLeaderAttribute(e.target.value.toUpperCase())} 
                        />
                    ) : (
                        <Text>{props.latLeaderAttribute || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Descripción del atributo del líder */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Descripción:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newLeaderAttribute ? (
                        <Input 
                            value={props.latDescription} 
                            onChange={(e) => props.setLatDescription(e.target.value.toUpperCase())} 
                        />
                    ) : (
                        <Text>{props.latDescription || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Comportamientos del atributo */}
            {props.latBehaviors?.map((behavior, index) => (
                <Row key={index} align="middle" style={{ marginBottom: 10 }}>
                    <Col span={4}><Text>Comportamiento {index + 1}:</Text></Col>
                    <Col span={20}>
                        {isEditing || props.newLeaderAttribute ? (
                            <TextArea
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                value={behavior.lab_behavior}
                                onChange={(e) => handleBehaviorChange(index, e.target.value)}
                            />
                        ) : (
                            <Text>{behavior.lab_behavior || "No especificado"}</Text>
                        )}
                    </Col>
                </Row>
            ))}

            {/* Botones */}
            <Row justify="end" style={{ marginTop: 20 }}>
                <Space>
                    {props.newLeaderAttribute ? (
                        <Button type="primary" onClick={handleCreateClick}>Guardar</Button>
                    ) : isEditing ? (
                        <>
                            <Button type="primary" onClick={handleSaveClick}>Guardar</Button>
                            <Button onClick={() => setIsEditing(false)}>Cancelar</Button>
                        </>
                    ) : (
                        <Button type="default" onClick={handleEditClick}>Editar</Button>
                    )}
                </Space>
            </Row>
        </Form>
    );
};

export default FormLeaderAttribute;
